import api from '@api/getBook'

export default {
  namespaced: true,
  state: {
    currentManageContent: 'MyBooks',
    currentSidebarOpenIndex: 0,
    currentSidebarIndex: 0,
    currentSidebarSubIndex: 0,
    bookListPages: -1,
    alreadyUse: 0,
    allSpace: 0,
    componentManager: 'Published', // 管理组件状态
    currentSubAccountSidebarIndex: 0, // 子账号当前父级目录
    currentSubAccountManageContent: '', // 子账号当前组件
    booksCurrentSubAccount: '' //显示作品列表的子账号
  },
  mutations: {
    UPDATE_CURRENT_MANAGE(state, name) {
      state.currentManageContent = name
    },
    UPDATE_SIDEBAR_SUBINDEX(state, index) {
      state.currentSidebarSubIndex = index
    },
    UPDATE_SIDEBAR_INFO(state, info) {
      state.currentSidebarSubIndex = info.subIndex
      state.currentSidebarIndex = info.index
      state.currentManageContent = info.component
    },
    UPDATE_SIDEBAR_OPEN_INDEX(state, index) {
      state.currentSidebarOpenIndex = index
    },
    UPDATE_SUB_ACCOUNT_SIDEBAR_INFO(state, info) {
      state.currentSubAccountSidebarIndex = info.index
      state.currentSubAccountManageContent = info.component
    },
    UPDATE_BOOK_LIST_PAGES(state, count) {
      state.bookListPages = count
    },
    UPDATE_BOOK_USE(state, alreadyUse) {
      state.alreadyUse = alreadyUse
    },
    UPDATE_BOOK_ALLSPACE(state, allSpace) {
      state.allSpace = allSpace
    },
    //更新专辑组件状态
    UPDATE_COMPONENTMANAGER(state, componentManager) {
      state.componentManager = componentManager
    },
    UPDATE_BOOKS_CURRENT_ACCOUNT(state, account) {
      state.booksCurrentSubAccount = account
    }
  },
  actions: {
    // 获取空间信息
    async getSpace({ rootGetters, state }) {
      const userName = rootGetters['common/userName']
      const isSubAccount = rootGetters['common/isSubAccount']
      if (userName) {
        if (isSubAccount == 1 || isSubAccount == 0) {
          const params = {
            userName: userName,
            isChild: isSubAccount
          }
          await api.getChildUserSpace(params).then((res) => {
            if (res.status == 200 && res.data.code == 0) {
              if (res.data.data) {
                state.alreadyUse = Math.floor(res.data.data.usedSpace / (1024 * 1024))
                state.allSpace = Math.floor(res.data.data.spaceLimit / (1024 * 1024 * 1024))
              }
            }
          })
        } else {
          const params = {
            name: userName
          }
          await api.getUserSpace(params).then((res) => {
            if (res.status == 200) {
              if (res.data.data) {
                state.alreadyUse = Math.floor(res.data.data.usedSpace / (1024 * 1024))
                state.allSpace = Math.floor(res.data.data.spaceLimit / (1024 * 1024 * 1024))
              }
            }
          })
        }
      }
    }
  }
}
